import $ from 'jquery';
window.$ = window.jQuery = $;
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules'
window.Swiper = Swiper;
window.SwiperModes = {
    'Navigation': Navigation,
    'Pagination': Pagination,
    'Autoplay': Autoplay,
    'FreeMode': FreeMode
};
import lightGallery from 'lightgallery';
window.lightGallery = lightGallery;
import lgVideo from 'lightgallery/plugins/video';
import lgAutoplay from 'lightgallery/plugins/autoplay';
window.lgModules = {
    'lgVideo': lgVideo,
    'lgAutoplay': lgAutoplay

}
import Inputmask from 'inputmask';
window.Inputmask = Inputmask

require('./header');
require('./form');
require('./additions/slider');
require('./additions/partners');
require('./additions/blog');
require('./additions/donate');
// require('./additions/ext-blog');
require('./additions/gallery');
require('./additions/video-gallery');

$(document).ready(function () {
    adaptVideo()
    iframeInit()
    iframeAdapt()
    youtubeFrame()
    selectInit()
    setTimeout(function() {
        videoBtnPosAdapt()
    }, 50)
})

$(document).on('click', '.form__select-value', function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        $(this).next('.form__select-list').slideUp(300)
    } else {
        $(this).addClass('active')
        $(this).next('.form__select-list').slideDown(300)
    }
})

$(document).on('click', '.form__select-item', function () {
    let wrapper = $(this).closest('.form__select-wrapper')
    let text = $(this).text()
    wrapper.find('.form__select-value').addClass('choosed').removeClass('active').text(text)
    wrapper.find('.form__select-list').slideUp(300)
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    wrapper.prev('.js_form__select').val($(this).attr('data-val'))
})

$(document).on('click', function (e) {
    if (!$(e.target).closest('.form__select-wrapper').length && !$(e.target).hasClass('js_select')) {
        $('.form__select-value').removeClass('active')
        $('.form__select-list').slideUp(300)
    }
})

$(window).on('resize', function () {
    adaptVideo()
    iframeAdapt()
    videoBtnPosAdapt()
})

$(document).on('click', '.js_faq__item-title', function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        $(this).next('.js_faq__item-text').slideUp(300)
    } else {
        $(this).closest('.js_faq').find('.js_faq__item-title').removeClass('active')
        $(this).closest('.js_faq').find('.js_faq__item-text').slideUp(300)
        $(this).addClass('active')
        $(this).next('.js_faq__item-text').slideDown(300)
    }
})

$(document).on('click', '.js_history__btn', function () {
    $(this).closest('.js_history__item').find('.js_history__modal').addClass('active')
    $('body').addClass('overflow')
})

$(document).on('click', '.js_history__close', function () {
    $(this).closest('.js_history__modal').removeClass('active')
    $('body').removeClass('overflow')
})

$(document).on('click', '.js_video-big__btn', function () {
    $(this).siblings('.js_video-big__video').find('video')[0].play()
    $(this).remove()
})

async function adaptVideo() {
    $('.js_text-left__video').each((i, el) => {
        let big = $(el).attr('data-big')
        let small = $(el).attr('data-small')
        if ($(window).innerWidth() > 567 && $(el).attr('src') != big) {
            $(el).attr('src', big)
        } else if ($(window).innerWidth() < 568 && $(el).attr('src') != small) {
            $(el).attr('src', small)
        }
    })
}

function videoBtnPosAdapt() {
    $('.js_video-big__btn').each((i, el) => {
        if ($(window).outerWidth() < 768) {
            let videoHeight = $(el).siblings('.js_video-big__video').outerHeight()
            console.log(videoHeight)
            $(el).css('top', videoHeight / 2 - 40)
        } else {
            $(el).removeAttr('style')
        }
    })
}

function iframeInit() {
    $('.js_frame').each((i, el) => {
        let link = $(el).find('iframe').attr('src')
        let newLink = ''
        if ($(el).hasClass('js_frame_controls')) {
            newLink = link.slice(0, link.indexOf('&')) + "controls=1"
        } else {
            newLink = link.slice(0, link.indexOf('&')) + "&title=0&muted=1&autoplay=1&autopause=0&controls=0&loop=1"
        }
        $(el).find('iframe').attr('src', newLink)
    })
}

function iframeAdapt() {
    $('.js_frame').each((i, el) => {
        let height = $(el).children('div').innerHeight()
        let parentHeight = $(el).closest('.js_frame-parent').innerHeight()
        if (parentHeight / height > 1) {
            $(el).children('div').css('transform', `scale(${parentHeight / height})`)
        }
    })
}

function youtubeFrame() {
    $('.js_youtube').each((i, el) => {
        let link = $(el).find('iframe').attr('src')
        let newLink = ''
        if ($(el).hasClass('js_youtube_controls')) {
            newLink = link.slice(0, link.indexOf('&')) + "controls=1"
        } else {
            newLink = link.slice(0, link.indexOf('&')) + "&title=0&mute=1&autoplay=1&autopause=0&controls=0&loop=1"
        }
        let width = $(el).find('iframe').attr('width')
        let height = $(el).find('iframe').attr('height')
        $(el).css('padding-top', `${height / width * 100}%`)
        $(el).find('iframe').attr('src', newLink)
    })
}

function selectInit() {
    $('.js_select').each((i, el) => {
        let element = $('<div class="form__select-wrapper"></div>')
        let text = $(`<div class="form__select-value">${$(el).attr('data-placeholder')}</div>`)
        let list = $('<ul class="form__select-list"></ul>')
        text.appendTo(element)
        list.appendTo(element)
        $(el).find('option').each((ind, elem) => {
            let text = $(elem).text()
            let value = $(elem).prop('value')
            let option = $(`<li data-val="${value}" class="form__select-item">${text}</li>`)
            option.appendTo(list)
        })
        $(el).after(element)
    })

    $('.js_form__phone').each((i, el) => {
        Inputmask('+38 (099) 999-99-99').mask(el)
    })
}